import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TDSEntry, TDSEntryCreate, TDSEntryFilter } from '../data/tDSEntry';

export function createTDSEntryService(client: AxiosInstance) {
  return createCrudService<TDSEntry, TDSEntryCreate, TDSEntryFilter>(
    client,
    '/accounting/TDSEntry',
    'id',
  );
}

export type TDSEntryService = CrudService<TDSEntry, TDSEntryCreate, TDSEntryFilter>;
